import React from "react";
import "./hero.css";

function Hero() {
  return (
    <>
      <figure className="position-relative hero-img">
        <img
          src={`/assets/glen-headshot.png`}
          alt="Glen Callahan — Developmental Coach in Tauranga, New Zealand"
          className="img-fluid "
        />
        <figcaption className="hero__quote">
          <h1 className="hero__font">
            Get clarity on where you are and what to do next.
          </h1>
          <a
            href="https://calendly.com/glen-coaching/strategy"
            target="_blank"
            rel="noreferrer"
          >
            <button className="btn__cta">
              Schedule a call&nbsp;&nbsp;&rarr;
            </button>
          </a>
        </figcaption>
      </figure>
    </>
  );
}

export default Hero;
